import { Tool } from '@procureai/agents';
import { useTranslation } from 'react-i18next';

import { ChatLoadingIndicator } from '../ChatMessage/indicators/ChatLoadingIndicator';
import { ChatToolErrorIndicator } from '../ChatMessage/indicators/ChatToolErrorIndicator';
import { ChatToolResultIndicator } from '../ChatMessage/indicators/ChatToolResultIndicator';
import {
  SvbrgSearchMaterialInput,
  SvbrgSearchMaterialOutput,
  SvbrgSearchMaterialStatus,
} from '@/generated/gql/graphql';
import { I18nNamespace } from '@/legacy/common/types';

import { ToolResultComponent } from '.';

const formatQuery = (query: string[] | undefined): string => {
  if (!query || query.length === 0) return '*';
  return query.join(', ');
};

export const SearchMaterialTool: ToolResultComponent<
  Tool.searchMaterial,
  SvbrgSearchMaterialInput,
  SvbrgSearchMaterialOutput
> = ({ tool, toolName }) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: `Chat.tools.${toolName}` });

  const query = formatQuery(tool.input?.query);

  switch (tool.state) {
    case 'input-streaming':
    case 'input-available':
      return <ChatLoadingIndicator message={t('call', { query })} />;

    case 'output-error':
      return <ChatToolErrorIndicator message={t('error')} />;

    case 'output-available':
      if (tool.output.status === SvbrgSearchMaterialStatus.no_sap_access) {
        return <ChatToolResultIndicator message={t('noSapAccess')} defaultOpen={false} disabled={true} />;
      }
      if (tool.output.error) {
        return <ChatToolErrorIndicator message={t('error')} />;
      }
      return <ChatToolResultIndicator message={t('result', { query })} defaultOpen={false} disabled={true} />;
  }
};
